




















































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { Auth } from 'aws-amplify';

@Component({
  components: {
    CommonButton,
  },
})
export default class ResendSignUpModal extends Vue {
  @Prop({ required: true })
  private isOpenResendSignUpModal!: boolean;
  private commonButtonColorClose: string = '#359cf3';
  private accountName = '';

  private async onResendSignUp() {
    try {
      if (this.accountName === '') {
        alert('アカウント名は必須です。');
        return;
      }
      await Auth.resendSignUp(this.accountName);
      alert('確認コードが送信されました。');
      this.closeResendSignUpModal();
    } catch (error) {
      if (error.code && error.code === 'CodeDeliveryFailureException') {
        alert('コードの送信に失敗しました。');
      } else {
        alert('予期しないエラーが発生しました。');
      }
      this.closeResendSignUpModal();
    }
  }

  @Emit('closeResendSignUpModal')
  private closeResendSignUpModal(): void {}
}
